import { render, staticRenderFns } from "./media-filters.vue?vue&type=template&id=4bf3f7f3"
import script from "./media-filters.vue?vue&type=script&lang=js"
export * from "./media-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports